import { Location } from 'history'

import { parse } from 'query-string'

import { DISABLE_SCROLL_TOP_ROUTES } from './consts'

export const checkDisabledLocation = (location: Location) => {
  const queryParams = DISABLE_SCROLL_TOP_ROUTES[location.pathname]

  if (!queryParams) return false
  if (queryParams.length === 0) return true

  const parsed = parse(location.search)

  return queryParams.every(param => !!parsed[param])
}
